<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <b-row class="justify-content-between px-1 align-items-center">
          <b-col>
            <validation-filters class="mt-1" @filterChanged="onFilterChanged" />
            
          </b-col>
          <b-col xl="3" cols="12">
            <b-input-group dir="rtl" class="input-group-merge">
              <b-form-input
                v-model="searchKey"
                placeholder="أدخل اسم المنظمة أو جزء منه ..."
              />
              <b-input-group-append is-text>
                <feather-icon
                  v-if="searchKey && searchKey.length > 0"
                  class="cursor-pointer"
                  @click="searchKey = null"
                  icon="XIcon"
                />
                <feather-icon v-else icon="SearchIcon" />
              </b-input-group-append>
            </b-input-group>
          </b-col>
          
        </b-row>

        <hr />

        <data-table
          id="ngos-table"
          ep="v2/ministry/ngo-completion"
          :fields="tableFields"
          ref="ngosTable"
          striped
          exportable
        >
          <template #cell(name_ar)="{ value, item }">
            <b-link @click="onLinkClicked(item)" class="align-middle">{{
              value
            }}</b-link>
          </template>
          <template #cell(weightsInfo.mark)="{ value }">
            <span class="text-info h4">{{ value }} %</span>
          </template>
          <template #cell(weightsInfo.completion)="{ value }">
            <span class="text-success h4">{{ value }} %</span>
          </template>
          <template #cell(completed_by_directorate_at)="{ value }">
            <span
              >{{ value ? $moment(value).format("HH:mm DD-MM-YYYY") : "" }}
            </span>
          </template>
          <template #cell(completed_by_ngo_at)="{ value }">
            <span
              >{{ value ? $moment(value).format("HH:mm DD-MM-YYYY") : "" }}
            </span>
          </template>
          <template #cell(completed_by_ministry_at)="{ value }">
            <span
              >{{ value ? $moment(value).format("HH:mm DD-MM-YYYY") : "" }}
            </span>
          </template>
          <template #cell(actions)="{ item }">
            <div class="d-flex justify-content-end">
              <template
                v-if="activeFilter === 'requests' &&
                 ( !item.completed_by_directorate ||
                  (!item.completed_by_ministry && isCentral))
                "
              >
                <b-button
                  @click="onValidateClicked(item.id)"
                  variant="success"
                  size="sm"
                >
                  مصادقة
                </b-button>
                <b-button
                  @click="onRefuseClicked(item.id)"
                  variant="danger"
                  size="sm"
                  class="mx-50"
                >
                  رفض
                </b-button>
                <b-button
                  v-if="activeFilter === 'central_rejected'"
                  @click="viewReplay(item.feedback.content)"
                  variant="warning"
                  size="sm"
                >
                  عرض الرد
                </b-button>
              </template>

              <b-button
                v-if="activeFilter === 'accepted'"
                @click="onRevokeClicked(item.id)"
                variant="danger"
                size="sm"
                class="mx-50"
              >
                إلغاء المصادقة
              </b-button>
            </div>
          </template>
        </data-table>
      </div>
    </b-card>
    <form-modal
      ref="replyModal"
      :formSchema="replyFormSchema"
      title="إرسال رد"
      v-model="replyModal"
      :loading="loading"
      @confirm="onReplyConfirmed"
      static
    />
    <b-modal
      size="lg"
      v-model="feedbackModal"
      footer-class="removed"
      title="الردود المركزية"
      centered
      header-class="bg-warning text-white"
    >
      <b-card-text class="p-1">
        <div>{{ feedbackContent }}</div>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BModal,
  BLink,
  BCol,
  BCard,
  BCardText,
  BButton,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormRadioGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormFile from "@/components/form-file/index.vue";
import FormInput from "@/components/form-input/index.vue";
import DataTable from "@/components/data-table";
import debounce from "lodash.debounce";
import ValidationFilters from "../../../../components/ValidationFilters.vue";
import authHelpers from "@/utils/auth-helpers";
import LoaderBtn from "@/components/loader-btn.vue";

export default {
  components: {
    BRow,
    BModal,
    BLink,
    BCol,
    BCard,
    BButton,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    MinistryBreadcrumbs,
    FormModal,
    FormFile,
    BCardText,
    FormInput,
    DataTable,
    BFormRadioGroup,
    ValidationFilters,
    LoaderBtn,
  },

  data() {
    return {
      mainTitle: "تدقيق بيانات المنظمات",
      ngoModal: false,
      type: "ADD",
      searchKey: null,
      idToSendReply: null,
      replyModal: false,
      feedbackModal: false,
      activeFilter: "all",
      feedbackContent: "",
      isCentral: authHelpers.isUserCentral(),
      replyFormSchema: {
        content: {
          component: "FormTextarea",
          key: "content",
          attrs: {
            label: "الرسالة",
            rules: "required",
          },
        },
      },
      fields: [
        { label: "المعرف", key: "id" },
        { label: "الاسم", key: "name_ar" },
        { label: "الشكل القانوني", key: "legalForm.name_ar" },
        { label: "محافظة المقر", key: "hq.name_ar" },
        { label: "حالة المنظمة", key: "status.name_ar" },
        { label: "رقم قرار الإشهار", key: "decision_no" },
        { label: "تاريخ قرار الإشهار", key: "decision_date" },
        {
          key: "calculatedWeight.completion_value",
          label: "اكتمال المعلومات الالزامية",
        },
        {
          key: "calculatedWeight.mark",
          label: "اكتمال بيانات المنظمة",
        },
      ],
      breadcrumbs: [
        // {
        //   text: "الإعدادات",
        //   to: "/ministry/settings",
        // },
        {
          text: "إدارة المنظمات",
          to: "/ministry/ngos-communication",
        },
        {
          text: "تدقيق بيانات المنظمات",
          active: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters("Ministry/Settings/NgosValidation", ["working"]),
    ...mapGetters("FeedbackModule", ["loading"]),
    ...mapGetters("Exporter", ["exporting"]),
    tableFields() {
      var actionsField = { label: " ", key: "actions" };
      var directorateCompletedField = {
        label: "اعتُمدَ من قبل المديرية بتاريخ",
        key: "completed_by_directorate_at",
      };
      var directorateCompletedUserField = {
        label: "اعتُمدَ من قبل المديرية من قبل",
        key: "completedByDirectorate.full_name",
      };

      var ngoCompletedField = {
        label: "اعتُمدَ من قبل المنظمة بتاريخ",
        key: "completed_by_ngo_at",
      };
      var ngoUserCompletedField = {
        key: "completed_by_ngo_name.full_name",
        label: "اعتُمدَ من قبل المنظمة من قبل",
      };
      var ministryCompletedField = {
        label: "اعتُمدَ من قبل الوزارة بتاريخ",
        key: "completed_by_ministry_at",
      };
      var ministryCompletedUserField = {
        label: "اعتُمدَ من قبل الوزارة من قبل",
        key: "completedByMinistry.full_name",
      };
      return this.activeFilter === "central_rejected"
        ? [
            ...this.fields,
            ngoCompletedField,
            ngoUserCompletedField,
            // directorateCompletedField,
            // directorateCompletedUserField,
            actionsField,
          ]
        : this.activeFilter === "requests" && authHelpers.isUserCentral()
        ? [
            ...this.fields,
            ngoCompletedField,
            ngoUserCompletedField,
            directorateCompletedField,
            directorateCompletedUserField,
            actionsField,
          ]
        : this.activeFilter === "requests" && !authHelpers.isUserCentral()
        ? [
            ...this.fields,
            ngoCompletedField,
            ngoUserCompletedField,
            actionsField,
          ]
        : this.activeFilter === "accepted" && authHelpers.isUserCentral()
        ? [
            ...this.fields,
            ngoCompletedField,
            ngoUserCompletedField,
            directorateCompletedField,
            directorateCompletedUserField,
            ministryCompletedField,
            ministryCompletedUserField,
            actionsField,
          ]
        : this.activeFilter === "accepted" && !authHelpers.isUserCentral()
        ? [
            ...this.fields,
            ngoCompletedField,
            ngoUserCompletedField,
            directorateCompletedField,
            directorateCompletedUserField,
          ]
        : this.activeFilter === "central_accepted"
        ? [
            ...this.fields,
            ngoCompletedField,
            ngoUserCompletedField,
            directorateCompletedField,
            directorateCompletedUserField,
            ministryCompletedField,
            ministryCompletedUserField,
            actionsField,
          ]
        : [...this.fields, ngoCompletedField, ngoUserCompletedField];
    },
  },
  watch: {
    searchKey: debounce(function (value) {
      this.$refs.ngosTable.setQueryParams({
        search: value,
        tab: this.activeFilter,
      });
      this.$refs.ngosTable.refreshTable();
    }, 300),
    activeFilter(val) {
      this.$refs.ngosTable.setQueryParams({ search: this.searchKey, tab: val });
      this.$refs.ngosTable.refreshTable();
    },
  },
  methods: {
    ...mapActions("Ministry/Settings/NgosValidation", ["validateNgo"]),
    ...mapActions("FeedbackModule", ["sendFeedback"]),
    ...mapActions("Exporter", ["exportToExcel"]),
    viewReplay(message) {
      this.feedbackContent = message;
      this.feedbackModal = true;
    },
    onSendReplyClicked(id) {
      this.idToSendReply = id;
      this.replyModal = true;
    },
    onReplyConfirmed(form) {
      this.sendFeedback({
        form,
        ep: `v2/ministry/ngo-feedback/${this.idToSendReply}`,
      })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تم إرسال الرد بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
              timeout: 3000,
            },
          });
          this.validateNgo({ id: this.idToSendReply, status: false }).then(
            () => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تمت رفض معلومات المنظمة بنجاح",
                  icon: "CheckSquareIcon",
                  variant: "success",
                  timeout: 3000,
                },
              });
              this.$refs.ngosTable.refreshTable();
            }
          );
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ أثناء إرسال الرد ",
              icon: "XIcon",
              variant: "danger",
              timeout: 3000,
            },
          });
        })
        .finally(() => {
          this.replyModal = false;
          this.idToSendReply = null;
        });
    },
    onLinkClicked(item) {
      localStorage.setItem("ni", item.id);
      localStorage.setItem("legalForm", item.legalForm.id);
      this.$router.push({ name: "ngo-profile" });
    },
    onFilterChanged(filter) {
      this.activeFilter = filter;
    },
    onValidateClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من المصادقة على معلومات المنظمة ؟", {
          title: "تأكيد المصادقة على معلومات المنظمة",
          size: "sm",
          okVariant: "success",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.validateNgo({ id, status: true })
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "تمت المصادقة على معلومات المنظمة بنجاح",
                    icon: "CheckSquareIcon",
                    variant: "success",
                    timeout: 3000,
                  },
                });
                this.$refs.ngosTable.refreshTable();
              })
              .catch(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "حدث خطأ أثناء العملية !",
                    icon: "XIcon",
                    variant: "danger",
                    timeout: 3000,
                  },
                });
              });
          }
        });
    },

    onRefuseClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من رفض معلومات المنظمة ؟", {
          title: "تأكيد رفض معلومات المنظمة",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.onSendReplyClicked(id);
          }
        });
    },
    onRevokeClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من إلغاء المصادقة على معلومات المنظمة ؟", {
          title: "تأكيد إلغاء المصادقة على معلومات المنظمة",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.validateNgo({ id, status: false }).then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تم إلغاء المصادقة على معلومات المنظمة بنجاح",
                  icon: "CheckSquareIcon",
                  variant: "success",
                  timeout: 3000,
                },
              });
              this.$refs.ngosTable.refreshTable();
            });
          }
        });
    },
  },
};
</script>
